import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/ui-bits";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFoundPage() {
  usePageMeta({
    title: "Page Not Found | 30 NORTH",
    description: "The page you're looking for may have moved or no longer exists.",
    path: null,
    noindex: true,
  });

  return (
    <section data-testid="not-found-page" className="bg-white py-24 sm:py-32 lg:py-40">
      <div className="container-30 max-w-2xl">
        <Reveal>
          <Eyebrow>Error 404</Eyebrow>
          <h1 className="mt-6 text-4xl font-black leading-[1.02] tracking-tight text-[#191c1e] sm:text-5xl">
            PAGE NOT FOUND.
          </h1>
          <p className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg">
            The page you're looking for may have moved or no longer exists.
          </p>
          <div className="mt-10">
            <Link
              to="/"
              data-testid="not-found-home-button"
              className="group inline-flex items-center justify-center gap-2 whitespace-nowrap bg-[#ff6a00] px-7 py-4 text-[13px] font-bold tracking-[0.12em] text-white shadow-[0_10px_24px_-10px_rgba(255,106,0,0.55)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#e05d00]"
            >
              RETURN TO HOME
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
